import type { AuditEvent, AuditQuery, PageResult } from '@quds/shared';
import { apiGet } from '@/lib/api';

/** Read-only audit trail from the Central Admin database. */
export const listActivity = (q: AuditQuery) =>
  apiGet<PageResult<AuditEvent>>('/activity', {
    businessId: q.businessId,
    search: q.search?.trim(),
    action: q.action,
    page: q.page,
    pageSize: q.pageSize,
  });
